//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"CreateFaceMethod",1,0],[1,"Radius",0,"Expression",0],[0,"RemoveParameters",1,0],[1,"SelectionEdge",0,"ScCollector",0],[1,"SelectionFace",0,"ScCollector",0]],[[[],"CreateReferenceBlend",{R_:{edgeBlend:"TaggedObject"}},0,0],[["featureGroup"],"SetReferenceBlendFeatureGroup",{},1,0],[[],"CreateReferenceBlendWithReplaceFace",{R_:{replaceFace:"TaggedObject"}},0,0],[[],"DeleteReplaceFaceObjects",{},0,0]],[]];
SPLM.Tooling.ReferenceBlendBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ReferenceBlendBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ReferenceBlendBuilder.FaceCreationMethod = Object.freeze({
    "Default" : "Default", "Replace" : "Replace"});

export default SPLM;